import React, { Fragment } from 'react';
import './index.scss';
import Select from "react-select";
import Spacer from '../../components/common/Spacer';
import MASTER_TYPE_CONFIG from '../../common/masterTypeConfig';
import { modeLoadType } from '../../utils/constants';
import { getReconciliationTypeOptions } from './reconciliationTypes';
import { isContractManagementMaster } from './contractManagementMasters';
// import { options } from 'winston-daily-rotate-file';
import { withRouter } from 'react-router-dom';


const FilterSection = (props) => {
  const {
    allBranchList,
    allDlno,
    allVehRegno,
    allSapMaterialCode,
    selectedBranchName,
    selectedBranchCode,
    selectedDlNO,
    selectedVehNo,
    selectedSapMaterialCode,
    selectedMaterialCode,
    handleOnChangeForBranchName,
    handleOnChangeForBranchCode,
    handleOnChangeForDlNo,
    handleOnChangeForVehNo,
    selectedCompanyCategory,
    handleOnChangeforCompanyCategory,
    handleOnChangeCompname,
    selectedCompanyName,
    handleOnChangeForSapMCode,
    handleOnChangeforMaterialCode,
    handleOnChangeForRoleName,
    MaterialCodeListData,
    handleOnChangeForDeptName,
    handleInputChange,
    CompanyList,
    master_type,
    // allData,
    departments,
    roles,
    departmentLIstValue,
    RoleListValue,
    filterRoleData,
    filterDeptData,
    companyDropdownNameInputChange,
    addgetVolumetricDatainfoSearch,
    handleInputChangeForBranchNameOrCode,
    subPlantsData,
    selectedSubPlantsData,
    handleOnChangeSubPlantsData,
    plantsAndDepotInputSearch,
    loadingVendors,
    selectedVendor,
    handleOnChangeLoadingVendor,
    loadingVendorsInputSearch,
    loadingBays,
    selectedBay,
    handleOnChangeLoadingBay,
    loadingBaySearch,
    MFSInputSearch,
    handleOnChangeMFS,
    selectedMfs,
    MfsMasterData,
    WBMasterList,
    selectedWBMaster,
    handleOnChangeWBMaster,
    handleOnChangeWBConversion,
    selectedWBConversion,
    WBConversionList,
    selectedWarehouseStorage,
    handleOnChangeWarehouseStorage,
    warehouseStorageList,
    materialConversionList,
    handleOnChangeMaterialConversion,
    selectedMaterialConversion,
    materialMrpOptions,
    selectedMrpMaterialCode,
    handleOnChangeMaterialCodeSelection,
    userOptions,
    selectedUserOption,
    handleOnChangePlantUserSelection,
    userInputSearch,
    rawMaterialName,
    selectedRawMaterialNameOption,
    handleOnChangeRawMaterialName,
    rawMaterialNameInputSearch,
    lrPrefixOptions,
    selectedLRPrefix,
    handleOnChangeLrPrefix,
    selectedIndentManagementReason,
    handleOnChangeIndentManagementReason,
    genericAuditsearch,
    handleOnChangeGenericSearch,
    sapName,
    selectedSapNameOption,
    handleOnChangeSapName,
    sapNameInputSearch,
    mannedWeighBridgeDataName,
    selectedMannedWeighBridgeNameOption,
    handleOnChangeMannedWeighBridgeName,
    mannedWeighBridgeNameInputSearch,
    selectedRfDeviceNameOption,
    rfDeviceData,
    handleOnChangeRfDeviceName,
    rfDeviceNameInputSearch,
    toleranceMaterialOptions,
    selectedToleranceMaterialOption,
    handleOnChangeToleranceMaterial,
    toleranceMaterialInputSearch,
    transporterBypassName,
    selectedTransporterBypassNameOption,
    handleOnChangeTransporterBypassName,
    transporterBypassNameInputSearch,
    selectedModeLoadType,
    handleOnChangeModeLoadType,
    selectedReconciliationType,
    handleOnChangeReconciliationType,
    contractMasterOptions,
    selectedContractMaster,
    handleOnChangeContractMaster,
  } = props;
  
  const Complist  = (CompanyList||[]).map(obj => {
    return { ...obj, label: obj.company_name,value:obj.company_id };
});


const MaterialCodeList  = (MaterialCodeListData||[]).map(obj => {
  return { ...obj, label: obj.material_code,value:obj.material_code };
});

const filterWBMasterList  = (WBMasterList||[]).map(obj => {
  return { ...obj, label: obj.vendor_name,value:obj.vendor_name };
});

const filterWBConversionList  = (WBConversionList||[]).map(obj => {
  return { ...obj, label: obj.Vendor,value:obj.Vendor };
});

const filterWarehouseStorageList  = (warehouseStorageList||[]).map(obj => {
  return { ...obj, label: obj.warehouse_name,value:obj.warehouse_name };
});

const filterMaterialConversionList  = (materialConversionList||[]).map(obj => {
  return { ...obj, label: obj.Material,value:obj.Material };
});

const filterMaterialMrpOptions = (materialMrpOptions||[]).map(obj => {
  return { ...obj, label: obj.material_code,value:obj.material_code };
});

const filterUserOptions = (userOptions||[]).map(obj => {
  return { ...obj, label: obj.user_name,value:obj.user_id };
});

  const filterMaterialName = (rawMaterialName || []).map(obj => {
  return { ...obj, label: obj.product_name, value: obj.product_name };
});
  const filterSapName = (sapName || []).map(obj => {
  return { ...obj, label: obj.name, value: obj.name };
});

  const filterMannedWeighBridgeName = (mannedWeighBridgeDataName || []).map(obj => {
  return { ...obj, label: obj.plant_name, value: obj.plant_name };
});

  const filterRFDeviceName = (rfDeviceData || []).map(obj => {
    return { ...obj, label: obj.device_name, value: obj.device_name };
});

  const filterTransporterBypassName = (transporterBypassName || []).map(obj => {
    return { ...obj, label: obj.transporter_name, value: obj.transporter_name };
});
  const options = [
    { value: '1', label: 'Seekers', name: 'Seeker' },
    { value: '2', label: 'Providers', name: 'Provider' },
    { value: '3', label: '3PL', name: '3PL' },
    { value: '4', label: 'Fleet Owner & Broker', name: 'Fleet Owner & Broker' },
    { value: '5', label: 'Fleet Owner', name: 'Fleet Owner' },
    { value: '6', label: 'Broker', name: 'Broker' },
    { value: '7', label: 'Fleet Owner & Transporter', name: 'Fleet Owner & Transporter' },
    // { value: '8', label: 'Aggregators', name: 'Aggregator'},
    { value: '9', label: 'Surveyors', name: 'Surveyor' },
    { value: '10', label: 'Lashers', name: 'Lasher' },
    { value: '21', label: 'Handling Agents', name: 'Handling Agent' },
    { value: '22', label: 'Shipping Liners', name: 'Shipping Liner' },
    { value: '11', label: 'Fleet Owner and Company', name: 'Fleet Owner and Company'},
    { value: '8', label: 'Multi Service', name: 'Multi Service'},
    { value: '24', label: 'Buyer', name: 'Buyer'}
  ];

  const departmentsList  =filterDeptData && filterDeptData.map(obj => {
    return { ...obj, label: obj.department_name,value:obj.department_id };
  });
const rolesList  = filterRoleData && filterRoleData.map(obj => {
  return { ...obj, label: obj.role_name,value:obj.role_id };
});

  const IndentManagementReasonOptions = [
    { value: '1', label: 'Cancel Reason' },
    { value: '2', label: 'Regret Reason' },
    { value: '3', label: 'Reject Reason' },
  ]

  return (
    <Fragment>
      <div className='bg-627FE9 flex items-center gap-15 p-12 rounded-md flex-wrap'>
         <Fragment>
          { (master_type == MASTER_TYPE_CONFIG.PLANT_DEPOT || master_type == MASTER_TYPE_CONFIG.LOCATION_NETWORK || master_type == MASTER_TYPE_CONFIG.PLANT_INDENTS) &&
           <div>
            <label className='labelT1' >Branch Name</label>
            <Spacer spacing = {'3px'} />
            <Select
              className="react-select-container-T1"
              options={allBranchList}
              getOptionLabel={(option) => option.branch_name}
              getOptionValue={(option) => option.branch_id}
              isClearable = {true}
              value={selectedBranchName}
              onChange = {handleOnChangeForBranchName}
              onInputChange={handleInputChangeForBranchNameOrCode}
            />
           </div>
          }
         </Fragment>
         <Fragment>
          { (master_type == MASTER_TYPE_CONFIG.PLANT_DEPOT ||
             master_type == MASTER_TYPE_CONFIG.LOCATION_NETWORK ||
             master_type == MASTER_TYPE_CONFIG.INVENTORY_MASTER || 
             master_type == MASTER_TYPE_CONFIG.PLANT_INDENTS) &&
           <div>
            <label className='labelT1' >Branch Code</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={allBranchList}
             getOptionLabel={(option) => option.branch_code}
             getOptionValue={(option) => option.branch_code}
             isClearable = {true}
             value={selectedBranchCode}
             onChange = {handleOnChangeForBranchCode}
             onInputChange={handleInputChangeForBranchNameOrCode}
            />
           </div>
          }
         </Fragment>
         <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.DRIVER_MASTER) &&
           <div>
            <label className='labelT1' >DL Number</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={allDlno}
             isClearable = {true}
             value={selectedDlNO}
             onChange = {handleOnChangeForDlNo}
             onInputChange={(e)=>{handleInputChange(e)}}
            />
           </div>
          }
          {(master_type == MASTER_TYPE_CONFIG.DEPARTMENT_ROLES) &&
           <div>
            <label className='labelT1' >Department Name</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={departmentsList}
             isClearable = {true}
             value={departmentLIstValue}
             onChange = {handleOnChangeForDeptName}
            />
           </div>
          }
          {(master_type == MASTER_TYPE_CONFIG.DEPARTMENT_ROLES) &&
           <div>
            <label className='labelT1' >Role Name</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={rolesList}
             isClearable = {true}
             value={RoleListValue}
            onChange = {handleOnChangeForRoleName}
            />
           </div>
          }
         </Fragment>
         <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.TRUCK_MASTER) &&
          <div>
            <label className='labelT1'>Vehicle Reg Number</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={allVehRegno}
             isClearable = {true}
             value = {selectedVehNo}
             onChange = {handleOnChangeForVehNo}
             onInputChange={(e)=>{handleInputChange(e)}}
            />
          </div>
          }
          {(master_type == MASTER_TYPE_CONFIG.COMPANY_INFO) &&
          <div>
           <label className='labelT1'>Company Category</label>
           <Spacer spacing = {'3px'} />  
           <Select className="react-select-container-T1" 
            value={selectedCompanyCategory} 
            onChange={handleOnChangeforCompanyCategory}
            options={options} />
          </div>
          } 
          {(master_type == MASTER_TYPE_CONFIG.COMPANY_INFO) &&
          <div>
            <label className='labelT1'>Company Name</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={Complist}
             isClearable = {true}
             value ={selectedCompanyName}
             onChange = {handleOnChangeCompname}
             onInputChange={(searchText)=>(companyDropdownNameInputChange(searchText))}
            //  onInputChange={(e)=>{handleInputChange(e)}}
            />
          </div>
          }
         </Fragment>
         <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.VENDOR_MAPPING) && 
          <div>
            <label className='labelT1'>Sap Material Code</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={allSapMaterialCode}
             isClearable = {true}
             value = {selectedSapMaterialCode}
             onChange = {handleOnChangeForSapMCode}
             onInputChange={(e)=>{handleInputChange(e)}}
            />
          </div>
          }
         </Fragment>
         <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.VOLUMETRIC_WEIGHT) && 
          <div>
            <label className='labelT1'>Material Code</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={MaterialCodeList}
             isClearable = {true}
             value = {selectedMaterialCode}
             onChange = {handleOnChangeforMaterialCode}
            onInputChange={(searchText)=>(addgetVolumetricDatainfoSearch(searchText))}
            />
          </div>
          }
         </Fragment>
         <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.SUB_PLANTS) && 
          <div>
            <label className='labelT1'>Sub Plant</label>
            <Spacer spacing = {'3px'} />
            <Select
             className="react-select-container-T1"
             options={subPlantsData}
             isClearable = {true}
             value = {selectedSubPlantsData}
             onChange = {handleOnChangeSubPlantsData}
            onInputChange={(searchText)=>(plantsAndDepotInputSearch(searchText))}
            />
          </div>
          }
         </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.LOADING_VENDOR) &&
            <div>
              <label className='labelT1'>Vendor Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={loadingVendors}
                isClearable={true}
                value={selectedVendor}
                onChange={handleOnChangeLoadingVendor}
                onInputChange={(searchText) => (loadingVendorsInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.LOADING_BAY) &&
            <div>
              <label className='labelT1'>Bay Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={loadingBays}
                isClearable={true}
                value={selectedBay}
                onChange={handleOnChangeLoadingBay}
                onInputChange={(searchText) => (loadingBaySearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.MFS_MASTER) &&
            <div>
              <label className='labelT1'>Material code</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={MfsMasterData}
                isClearable={true}
                value={selectedMfs}
                onChange={handleOnChangeMFS}
                onInputChange={(searchText) => (MFSInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.WEIGH_BRIDGE_MASTER) &&
            <div>
              <label className='labelT1'>Vendor Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterWBMasterList}
                isClearable={true}
                value={selectedWBMaster}
                onChange={handleOnChangeWBMaster}
                // onInputChange={(searchText) => (MFSInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.WEIGH_BRIDGE_CONVERSION) &&
            <div>
              <label className='labelT1'>Vendor Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterWBConversionList}
                isClearable={true}
                value={selectedWBConversion}
                onChange={handleOnChangeWBConversion}
                // onInputChange={(searchText) => (MFSInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.WAREHOUSE_WISE_STORAGE) &&
            <div>
              <label className='labelT1'>Warehouse Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterWarehouseStorageList}
                isClearable={true}
                value={selectedWarehouseStorage}
                onChange={handleOnChangeWarehouseStorage}
                // onInputChange={(searchText) => (MFSInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.MATERIAL_CONVERSION) &&
            <div>
              <label className='labelT1'>Material</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterMaterialConversionList}
                isClearable={true}
                value={selectedMaterialConversion}
                onChange={handleOnChangeMaterialConversion}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.MATERIAL_MRP) &&
            <div>
              <label className='labelT1'>Material Code</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterMaterialMrpOptions}
                isClearable={true}
                value={selectedMrpMaterialCode}
                onChange={handleOnChangeMaterialCodeSelection}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.PLANT_USERS) &&
            <div>
              <label className='labelT1'>User Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterUserOptions}
                isClearable={true}
                value={selectedUserOption}
                onChange={handleOnChangePlantUserSelection}
                onInputChange={(searchText) => (userInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.RAW_MATERIAL_MASTER) &&
            <div>
              <label className='labelT1'>Material Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterMaterialName}
                isClearable={true}
                value={selectedRawMaterialNameOption}
                onChange={handleOnChangeRawMaterialName}
                onInputChange={(searchText) => (rawMaterialNameInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.SAP_MASTER) &&
            <div>
              <label className='labelT1'>Sap Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterSapName}
                isClearable={true}
                value={selectedSapNameOption}
                onChange={handleOnChangeSapName}
                onInputChange={(searchText) => (sapNameInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.MANNED_WEIGHBRIDGE_MASTER) &&
            <div>
              <label className='labelT1'>Manned WeighBridge Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterMannedWeighBridgeName}
                isClearable={true}
                value={selectedMannedWeighBridgeNameOption}
                onChange={handleOnChangeMannedWeighBridgeName}
                onInputChange={(searchText) => (mannedWeighBridgeNameInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.RF_DEVICE_MASTER) &&
            <div>
              <label className='labelT1'>Rf Device Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterRFDeviceName}
                isClearable={true}
                value={selectedRfDeviceNameOption}
                onChange={handleOnChangeRfDeviceName}
                onInputChange={(searchText) => (rfDeviceNameInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.TOLERANCE_MASTER) &&
            <div>
              <label className='labelT1'>Material</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={toleranceMaterialOptions}
                isClearable={true}
                value={selectedToleranceMaterialOption}
                onChange={handleOnChangeToleranceMaterial}
                onInputChange={(searchText, { action }) => { if (action === 'input-change') toleranceMaterialInputSearch(searchText); }}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.TRANSPORTER_BYPASS_MASTER) &&
            <div>
              <label className='labelT1'>Transporter Name</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={filterTransporterBypassName}
                isClearable={true}
                value={selectedTransporterBypassNameOption}
                onChange={handleOnChangeTransporterBypassName}
                onInputChange={(searchText) => (transporterBypassNameInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.DIGITAL_LR) &&
            <div>
              <label className='labelT1'>LR Prefix</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={lrPrefixOptions}
                isClearable={true}
                value={selectedLRPrefix}
                onChange={handleOnChangeLrPrefix}
                // onInputChange={(searchText) => (rawMaterialNameInputSearch(searchText))}
              />
            </div>
          }
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.INDENT_REASON) &&
            <div>
              <label className='labelT1'>Reason</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={IndentManagementReasonOptions}
                isClearable={true}
                value={selectedIndentManagementReason}
                onChange={handleOnChangeIndentManagementReason}
                onInputChange={(searchText) => (userInputSearch(searchText))}
              />
            </div>}
        </Fragment>
        <Fragment>
          {[MASTER_TYPE_CONFIG.ACCOUNT_MASTER,
            MASTER_TYPE_CONFIG.CREDIT_MASTER,
            MASTER_TYPE_CONFIG.DEBIT_MASTER].includes(+master_type) &&
            <Fragment>
              <div>
                <label className='labelT1'>Mode / Load Type</label>
                <Spacer spacing={'3px'} />
                <Select
                  className="react-select-container-T1"
                  options={modeLoadType}
                  isClearable={true}
                  value={selectedModeLoadType}
                  onChange={handleOnChangeModeLoadType}
                />
              </div>
              <div>
                <label className='labelT1'>Type</label>
                <Spacer spacing={'3px'} />
                <Select
                  className="react-select-container-T1"
                  options={getReconciliationTypeOptions(master_type, selectedModeLoadType)}
                  isClearable={true}
                  value={selectedReconciliationType}
                  onChange={handleOnChangeReconciliationType}
                />
              </div>
            </Fragment>}
        </Fragment>
        <Fragment>
          {master_type == MASTER_TYPE_CONFIG.ACCOUNT_EVENTS &&
            <div>
              <label className='labelT1'>Type</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={getReconciliationTypeOptions(master_type, null)}
                isClearable={true}
                value={selectedReconciliationType}
                onChange={handleOnChangeReconciliationType}
              />
            </div>}
        </Fragment>
        <Fragment>
          {isContractManagementMaster(master_type) &&
            <div>
              <label className='labelT1'>Master</label>
              <Spacer spacing={'3px'} />
              <Select
                className="react-select-container-T1"
                options={contractMasterOptions}
                isClearable={true}
                value={selectedContractMaster}
                onChange={handleOnChangeContractMaster}
              />
            </div>}
        </Fragment>
        <Fragment>
          {(master_type == MASTER_TYPE_CONFIG.VENDOR_LANE_MAPPING_MASTER) &&
            <div>
              <label className='labelT1'>From</label>
              <Spacer spacing={'3px'} />
              <input
                id={`search`}
                type='text'
                placeholder="Search by From"
                value={genericAuditsearch}
                onChange={(e) => {
                  handleOnChangeGenericSearch(e)
                }}
                style={{ width: '250px', height: '38px' }}
              />
            </div>}
          {(master_type == MASTER_TYPE_CONFIG.VEHICLE_PLANNING_SKU_MASTER) &&
            <div>
              <label className='labelT1'>Part Description</label>
              <Spacer spacing={'3px'} />
              <input
                id={`search`}
                type='text'
                placeholder="Search by Part Description"
                value={genericAuditsearch}
                onChange={(e) => {
                  handleOnChangeGenericSearch(e)
                }}
                style={{ width: '250px', height: '38px' }}
              />
            </div>}
          {(master_type == MASTER_TYPE_CONFIG.DISCOUNT_STRUCTURE_MASTER) &&
            <div>
              <label className='labelT1'>Vendor Name</label>
              <Spacer spacing={'3px'} />
              <input
                id={`search`}
                type='text'
                placeholder="Search by Vendor Name"
                value={genericAuditsearch}
                onChange={(e) => {
                  handleOnChangeGenericSearch(e)
                }}
                style={{ width: '250px', height: '38px' }}
              />
            </div>}
          {(master_type == MASTER_TYPE_CONFIG.VEHICLE_PLANNING_DRIVER_MASTER) &&
            <div>
              <label className='labelT1'>DL Number</label>
              <Spacer spacing={'3px'} />
              <input
                id={`search`}
                type='text'
                placeholder="Search by DL Number"
                value={genericAuditsearch}
                onChange={(e) => {
                  handleOnChangeGenericSearch(e)
                }}
                style={{ width: '250px', height: '38px' }}
              />
            </div>}
          {(master_type == MASTER_TYPE_CONFIG.VEHICLE_PLANNING_TRUCK_MASTER) &&
            <div>
              <label className='labelT1'>Vehicle Reg Number</label>
              <Spacer spacing={'3px'} />
              <input
                id={`search`}
                type='text'
                placeholder="Search by Vehicle Reg Number"
                value={genericAuditsearch}
                onChange={(e) => {
                  handleOnChangeGenericSearch(e)
                }}
                style={{ width: '250px', height: '38px' }}
              />
            </div>}
        </Fragment>
        {/* {<Fragment>
          <div>
            <label className='labelT1'>Search</label>
            <Spacer spacing={'3px'} />
            <input
              id={`search`}
              type='text'
              placeholder=" Search"
              value={GenericAuditsearch}
              onChange={(e) => {
                handleOnChangeGenericSearch(e)
              }}
              style={{ width: '250px', height: '38px' }}
            />
          </div>

        </Fragment>} */}
      </div>
    </Fragment>
  )
}

export default withRouter(FilterSection)
